<script setup lang="ts">
import { CookieBanner, useCookieBanner } from '@engage-web-ui/cookie-banner';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';

const runtimeConfig = useRuntimeConfig();
const route = useRoute();

const { cookiePolicyUrl, showBanner, onCookiesAccepted } = useCookieBanner({
  cookieDomain: runtimeConfig.public.globalCookieDomain,
  siteUrl: runtimeConfig.public.siteUrl,
});

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: '/favicon.svg',
    },
    {
      rel: 'canonical',
      href: joinPath(runtimeConfig.public.siteUrl, route.path),
    },
  ],
});
</script>

<template>
  <div class="app">
    <Header />
    <main>
      <nuxt-page />
    </main>
    <Footer />
    <CookieBanner
      v-if="showBanner"
      :cookie-policy-url="cookiePolicyUrl"
      @cookies-accepted="onCookiesAccepted"
    />
  </div>
</template>

<style scoped lang="scss">
.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
